/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * reporting frequency:
 *   * DAILY
 *   * WEEKLY
 *   * FORTNIGHTLY
 *   * MONTHLY
 *   * YEARLY
 */
export enum ReportFrequency {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  FORTNIGHTLY = 'FORTNIGHTLY',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY'
}
